<template>
  <div id="pageRomaneioAccess">
    <v-container grid-list-md fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="white"
          v-if="load"
        ></v-progress-circular>
      </div>
      <div>
        <v-data-table
          v-if="access.data"
          :headers="headers"
          :items="access.data"
          :mobile-breakpoint="960"
          disable-pagination
          disable-sort
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.user_data="{ item }">
            <div>{{ item.user.name }}</div>
            <div>{{ item.user.cpf | formatCpfCnpj }}</div>
          </template>
          <template v-slot:item.explorer="{ item }">
            <div>{{ item.explorer.name }}</div>
            <div>{{ item.explorer.document_number | formatCpfCnpj }}</div>
          </template>
          <template v-slot:item.approved="{ item, idx }">
            <!-- <span v-if="item.is_approved">Sim</span> -->
            <v-btn class="green text--white" small dark v-if="item.is_approved">
              Autorizado
            </v-btn>
            <v-btn
              class="d-md-flex"
              color="green"
              outlined
              small
              v-if="!item.is_approved"
              :loading="loadingSave"
              @click="grantRomaneioAccess(item, idx)"
            >
              <v-icon small class="mr-2">done</v-icon>
              Aprovar Acesso
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn color="red" dark small @click="deleteRomeneioAccess(item)">
              Excluir
            </v-btn>
          </template>
        </v-data-table>
      </div>

      <app-pagination
        v-if="access && access.pagination"
        :pagination="access.pagination"
        :disabled="paginatationDisabled"
        v-on:change-page="search"
      ></app-pagination>

      <v-dialog v-model="dialogAdd" max-width="500">
        <v-card>
          <v-card-title class="headline green white--text" primary-title>
            Permitir acesso
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="selectedProperty"
                    :items="properties"
                    item-text="name"
                    item-value="id"
                    label="Propriedade"
                    :clearable="true"
                    :loading="isLoadingProperty"
                    :search-input.sync="getProperties"
                    return-object
                    outlined
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="accessData.explorer"
                    :items="explorers"
                    item-text="name"
                    item-value="id"
                    label="Produtor"
                    :clearable="true"
                    return-object
                    outlined
                  ></v-autocomplete>
                  <div v-if="accessData.explorer">
                    <v-layout row wrap>
                      <v-flex xs4>Nome</v-flex
                      ><v-flex xs8>{{ accessData.explorer.name }}</v-flex>
                      <v-flex xs4>CPF/CNPJ</v-flex
                      ><v-flex xs8>{{
                        accessData.explorer.document_number | formatCpfCnpj
                      }}</v-flex>
                      <v-flex xs4>IE</v-flex
                      ><v-flex xs8>{{ accessData.explorer.ie }}</v-flex>
                    </v-layout>
                    <br />
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="accessData.user"
                    v-mask="'###.###.###-##'"
                    :items="users"
                    item-text="name"
                    item-value="id"
                    label="CPF do usuário já cadastrado na plataforma"
                    :clearable="true"
                    :loading="isLoadingUser"
                    :search-input.sync="getUser"
                    :filter="cpfFilter"
                    return-object
                    outlined
                  ></v-autocomplete>
                  <div v-if="accessData.user">
                    <v-layout row wrap>
                      <v-flex xs4>Nome</v-flex
                      ><v-flex xs8>{{ accessData.user.name }}</v-flex>
                      <v-flex xs4>CPF</v-flex
                      ><v-flex xs8>{{
                        accessData.user.cpf | formatCpfCnpj
                      }}</v-flex>
                      <v-flex xs4></v-flex
                      ><v-flex xs8
                        ><div v-if="accessData.user.picture"></div
                      ></v-flex>
                    </v-layout>
                    <br />
                  </div>
                </v-flex>
                <div v-if="accessAddError">
                  <v-alert type="error">
                    Selecione o usuário e o produtor.
                  </v-alert>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined @click="dialogAdd = false">
              Cancelar
            </v-btn>
            <v-btn
              color="green"
              dark
              @click="saveRomaneioAccess"
              :loading="btnRomaneioAccess"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogRemove" width="500">
        <v-card>
          <v-card-title class="headline red white--text" primary-title>
            Remover acesso romaneio
          </v-card-title>

          <v-card-text class="mt-6">
            <p>Tem certeza que deseja romover acesso?</p>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined @click="dialogRemove = false">
              Cancelar
            </v-btn>
            <v-btn color="red" dark @click="deleteRomeneioAccessConfirm">
              Remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-btn absolute dark fab top right color="orange" @click="dialogAdd = true">
      <v-icon>add</v-icon>
    </v-btn>

    <v-snackbar v-model="snackbar" color="success">
      Salvo com sucesso!
      <v-btn text @click="snackbar = false">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-snackbar>

    <v-snackbar v-model="errSnackbar" color="error">
      Erro ao tentar salvar
      <v-btn text @click="snackbar = false">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Vue from "vue";
import appApi from "../../plugins/api";
import ConfirmModal from "../../components/ConfirmModal";
import AppPagination from "../../components/Pagination";
import moment from "moment";

export default {
  components: {
    "app-pagination": AppPagination,
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      explorers: [],
      getExplorers: null,
      isLoadingProperty: false,
      dialogAdd: false,
      dialogRemove: false,
      loadingSave: false,
      load: true,
      paginatationDisabled: true,
      access: [],
      accessData: {
        explorer: null,
        user: null
      },
      users: [],
      isLoadingUser: false,
      getUser: null,
      accessAddError: false,
      btnRomaneioAccess: false,
      deleteItem: null,
      properties: [],
      getProperties: null,
      selectedProperty: null,
      snackbar: false,
      errSnackbar: false,
      headers: [
        { text: "Usúario / CPF", value: "user_data", sortable: false },
        { text: "Propriedade", value: "property.name", sortable: false },
        { text: "Produtor", value: "explorer", sortable: false },
        { text: "Aprovado?", value: "approved", sortable: false },
        { text: "", value: "actions", sortable: false }
      ]
    };
  },

  computed: {},

  mounted: function() {
    window.scrollTo(0, 0);

    var data = {};

    let open = false;
    if ("page" in this.$route.query) {
      data["page"] = this.$route.query.page;
    } else {
      data["page"] = 1;
      open = true;
    }

    this.getRomaneiosAccess(data, open);
    this.getPropertiesData();
  },

  methods: {
    deleteRomeneioAccess(item) {
      this.deleteItem = item;
      this.dialogRemove = true;
    },

    deleteRomeneioAccessConfirm() {
      appApi.deleteRomaneiosAccess(this.deleteItem.id).then(result => {
        this.deleteItem = null;
        this.dialogRemove = false;
        this.getRomaneiosAccess({ page: 1 });
      });
    },

    saveRomaneioAccess() {
      this.accessAddError = false;
      if (!this.accessData.user || !this.accessData.explorer) {
        this.accessAddError = true;
        return;
      }

      this.btnRomaneioAccess = true;
      appApi
        .postRomaneiosAccess({
          user_id: this.accessData.user.id,
          explorer_id: this.accessData.explorer.id
        })
        .then(result => {
          this.btnRomaneioAccess = false;
          this.dialogAdd = false;
          this.getRomaneiosAccess({ page: 1 });
          this.snackbar = true;
        })
        .catch(error => {
          this.btnRomaneioAccess = false;
        });
    },

    cpfFilter(item, queryText, itemText) {
      const cpf = queryText.replace(/\D/g, "");
      if (cpf === item.cpf) {
        return true;
      }

      return false;
    },

    search(page) {
      let data = {
        page: page && !isNaN(page) ? page : 1
      };
      this.$router.push({ name: "ExplorerAccess", query: data });
    },

    getRomaneiosAccess(data, open) {
      appApi.getRomaneiosAccess(data).then(result => {
        this.access = result.data;
        this.load = false;
        this.paginatationDisabled = false;
        this.dialogAdd = false;
      });
    },

    getExplorersData(name) {
      // Items have already been requested
      if (this.isLoadingExplorer) return;

      this.isLoadingExplorer = true;

      var data = {};
      if (name && name.trim().length > 0) {
        data["name"] = name.trim();
      }

      appApi
        .getExplorers(data)
        .then(result => {
          this.explorers = result.data.data;
        })
        .finally(() => (this.isLoadingExplorer = false));
    },

    getUserData(cpf) {
      if (!cpf || cpf.replace(/\D/g, "").length !== 11) {
        return;
      }
      // Items have already been requested
      if (this.isLoadingUser) return;

      this.isLoadingUser = true;

      var data = {
        cpf: cpf.replace(/\D/g, "")
      };

      appApi
        .getUsersByCpf(data)
        .then(result => {
          Vue.set(this, "users", [result.data]);
        })
        .finally(() => (this.isLoadingUser = false));
    },

    getPropertiesData(name) {
      appApi.getProperties({ name: name }).then(result => {
        this.properties = result.data.data;
      });
    },

    grantRomaneioAccess(item, idx) {
      appApi
        .putRomaneiosAccessRequest(item.id)
        .then(result => {
          this.loadingSave = true;
          item.is_approved = true;
          this.snackbar = true;
        })
        .catch(error => {
          this.loadingSave = true;
          this.errSnackbar = true;
        })
        .finally(() => (this.loadingSave = false));
    }
  },

  watch: {
    getExplorers(name) {
      this.getExplorersData(name);
    },
    getUser(cpf) {
      this.getUserData(cpf);
    },
    getProperties(name) {
      this.getPropertiesData(name);
    },
    selectedProperty: function(value) {
      if (value) {
        this.explorers = value.explorers;
      } else {
        this.explorers = [];
        this.accessData.explorer = null;
      }
    }
  }
};
</script>
<style scoped lang="css">
#pageRomaneioAccess >>> .v-data-table-header.v-data-table-header-mobile {
  display: none !important;
}
#pageRomaneioAccess {
  position: relative;
}

@media screen and (max-width: 960px) {
  #pageRomaneioAccess >>> .theme--light.v-data-table tbody tr td:first-child,
  #pageRomaneioAccess
    >>> .theme--light.v-data-table
    tbody
    tr:not(:last-child)
    td:last-child {
    border: 0px;
  }

  #pageRomaneioAccess >>> tbody tr {
    margin: 5px;
    border: 1px solid #e4e4e4;
    display: block;
    margin-bottom: 10px;
    border-radius: 4px;
    padding-bottom: 10px;
    overflow: hidden;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }
}
</style>
